// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    recaptcha: {
        siteKey: '6Lc3qI4qAAAAAMYueu_nLET2dX-K2NuRXVROC39F',
    },
    defaultAuth: {
        tennantID: '98682759-9c5a-464b-9d2f-52dd67b4e038',
    },
    backEndBaseUrl: 'https://api-dev.smilesmanager.com',
    // Add each third-party public API origin here before it is called by the application.
    authExcludedExternalOrigins: ['https://lista-firme.info'],
  };
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
